export default class LegMoveProfile {
  constructor(profileContainer) {
    this.profileContainer = profileContainer;
    this.districtContainer = this.profileContainer.parentElement;
    this.infoContainer = document.querySelector('.js-leg-info-container');
    this.mediaQuery = window.matchMedia('(max-width: 979px)');

    this.events();
  }

  events() {
    this.mediaQuery.onchange = () =>
      this.handleScreenChange(
        this.mediaQuery,
        this.infoContainer,
        this.profileContainer,
        this.districtContainer
      );

    this.handleScreenChange(
      this.mediaQuery,
      this.infoContainer,
      this.profileContainer,
      this.districtContainer
    );
  }

  handleScreenChange(e, infoContainer, profileContainer, districtContainer) {
    if (e.matches) {
      if (infoContainer) {
        infoContainer.insertBefore(profileContainer, infoContainer.children[2]);
      }
    } else {
      if (districtContainer) {
        districtContainer.appendChild(profileContainer);
      }
    }
  }
}
